// This function is necessary for changing the base URL to work with other applications
// (such as APIs)
// in the Dev environment (when you run npm start). Please make sure you really need
// this function before using it.
export const isDevEnvironment = process.env.NODE_ENV === 'development';
export const isProdEnvironment = process.env.NODE_ENV === 'production';

export default isDevEnvironment;
